import { useState } from 'react';

interface UseDialog {
    closeDialog: Function;
    isDialogOpen: boolean;
    openDialog: (event: React.MouseEvent) => void;
}

export const useDialog = (initialMode = false): UseDialog => {
    const [isDialogOpen, setDialogOpen] = useState(initialMode);
    const openDialog = (): void => setDialogOpen(true);
    const closeDialog = (): void => setDialogOpen(false);

    return {
        closeDialog,
        isDialogOpen,
        openDialog,
    };
};
